import UserView from './UserView.container';

export default UserView;
